import { createContext, useEffect, useState } from 'react';
// import { surveys } from '../utils/surveys';
import { fetchCatalogData } from '../api';

export const CatalogContext = createContext(null);

function CatalogContextProvider({ children }) {

  const [filters, setFilters] = useState([]);
  const [checkboxStates, setCheckboxStates] = useState({});
  const [filteredData, setFilteredData] = useState([]);
  const [gender, setGender] = useState(null);
  const [filteredMinAge, setFilteredMinAge] = useState(null);
  const [filteredMaxAge, setFilteredMaxAge] = useState(null);
  const [sortOption, setSortOption] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [surverys, setSurveys] = useState([]);
  const [catalogData, setCatalogData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [dataFilters, setDataFilters] = useState([]);

  const removeFilter = (filterToRemove) => {
    setFilters((prevFilters) => prevFilters.filter((filter) => filter !== filterToRemove));
    setCheckboxStates((prevState) => ({
      ...prevState,
      [filterToRemove]: false,
    }));
  };

  const clearFilters = () => {
    setFilters([]);
    setCheckboxStates({});
    setGender(null);
    setFilteredMaxAge(null);
    setFilteredMinAge(null);
  }

  const sortData = (data, option) => {
    const sortedData = [...data];
    if (option === 'A-Z') {
      sortedData.sort((a, b) => a.name.localeCompare(b.name));
    }
    else if (option === 'Z-A') {
      sortedData.sort((a, b) => b.name.localeCompare(a.name));
    }
    else if (option === 'SEN') {
      sortedData.sort((a, b) => a.sentiments - b.sentiments);
    }
    else if (option === 'SEN-D') {
      sortedData.sort((a, b) => b.sentiments - a.sentiments);
    }
    else if (option === 'PRC') {
      sortedData.sort((a, b) => a.practices - b.practices);
    }
    else if (option === 'PRC-D') {
      sortedData.sort((a, b) => b.practices - a.practices);
    }
    else if (option === 'HIST') {
      sortedData.sort((a, b) => a.history - b.history);
    }
    else if (option === 'HIST-D') {
      sortedData.sort((a, b) => b.history - a.history);
    }
    else if (option === 'INTR') {
      sortedData.sort((a, b) => a.interest - b.interest);
    }
    else if (option === 'INTR-D') {
      sortedData.sort((a, b) => b.interest - a.interest);
    }
    else if (option === 'AVG') {
      sortedData.sort((a, b) => {
        let average1 = a.sentiments + a.practices + a.history + a.interest;
        let average2 = b.sentiments + b.practices + b.history + b.interest;
        return average1 - average2;
      });
    }
    else if (option === 'AVG-D') {
      sortedData.sort((a, b) => {
        let average1 = a.sentiments + a.practices + a.history + a.interest;
        let average2 = b.sentiments + b.practices + b.history + b.interest;
        return average2 - average1;
      });
    }
    return sortedData;
  };

  const safeToLower = (value) => value ? value.toLowerCase() : '';

  const filterData = (gender, minAge, maxAge) => {
    let newData = [];
    filters.forEach(filter => {
      //   let x = catalogData.filter(dt => (dt.status === filter || dt.occupation.occupation === filter || dt.industry === filter));
      //   newData = [...newData, ...x];
      // });
      let x = catalogData.filter(dt => (dt.status === filter || dt.occupation === filter || dt.industry === filter));
      newData = [...newData, ...x];
    });
    if (gender) {
      newData = newData.filter(dt => dt.gender.toLowerCase() === gender);
    }
    if (minAge) {
      newData = newData.filter(dt => parseInt(dt.age, 10) >= minAge);
    }
    if (maxAge) {
      newData = newData.filter(dt => parseInt(dt.age, 10) <= maxAge);
    }
    if (sortOption !== null) {
      newData = sortData(newData, sortOption);
    }
    if (searchTerm) {
      newData = newData.filter(dt =>
        safeToLower(dt.name).includes(searchTerm.toLowerCase()) ||
        // safeToLower(dt.occupation.occupation).includes(searchTerm.toLowerCase()) ||
        safeToLower(dt.occupation).includes(searchTerm.toLowerCase()) ||
        safeToLower(dt.status).includes(searchTerm.toLowerCase()) ||
        // safeToLower(dt.occupation.occupational_group).includes(searchTerm.toLowerCase()) ||
        safeToLower(dt.occupational_group).includes(searchTerm.toLowerCase()) ||
        // safeToLower(dt.industry.industry).includes(searchTerm.toLowerCase()) ||
        safeToLower(dt.industry).includes(searchTerm.toLowerCase()) ||
        safeToLower(dt.gender).includes(searchTerm.toLowerCase())
      );
    }
    setFilteredData(newData);
  }

  const generateFilters = (key, surveys) => {
    if (key === 'status') {
      let surveysCopy = [...surveys];
      const statusCounts = surveysCopy.reduce((counts, { status }) => {
        if (status) {
          counts[status] = (counts[status] || 0) + 1;
        }
        return counts;
      }, {});

      let arr = Object.entries(statusCounts).map(([label, number]) => ({ label, number }));
      return arr;
    }
    if (key === 'occupation') {
      let surveysCopy = [...surveys];
      const occupationCounts = surveysCopy.reduce((counts, { occupation }) => {
        // if (occupation && occupation.occupation) {
        //   counts[occupation.occupation] = (counts[occupation.occupation] || 0) + 1;
        // }
        if (occupation) {
          counts[occupation] = (counts[occupation] || 0) + 1;
        }
        return counts;
      }, {});

      let arr = Object.entries(occupationCounts).map(([label, number]) => ({ label, number }));
      arr.sort((a, b) => b.number - a.number);
      return arr;
    }
    if (key === 'industry') {
      let surveysCopy = [...surveys];
      const industryCounts = surveysCopy.reduce((counts, { industry }) => {
        // if (industry && industry.industry) {
        //   counts[industry.industry] = (counts[industry.industry] || 0) + 1;
        // }
        if (industry) {
          counts[industry] = (counts[industry] || 0) + 1;
        }
        return counts;
      }, {});

      let arr = Object.entries(industryCounts).map(([label, number]) => ({ label, number }));
      arr.sort((a, b) => b.number - a.number);
      return arr;
    }
  }

  useEffect(() => {
    if (surverys.length > 0) {
      const df = [
        {
          id: 1,
          title: "Daily Work",
          search: false,
          values: generateFilters('status', surverys)
        },
        {
          id: 2,
          title: "Occupation",
          search: true,
          values: generateFilters('occupation', surverys)
        },
        {
          id: 3,
          title: "Industry",
          search: true,
          values: generateFilters('industry', surverys)
        }
      ];
      setDataFilters(df);
    }
  }, [surverys])

  useEffect(() => {
    if (filters.length > 0) {
      filterData(gender, filteredMinAge, filteredMaxAge);
    }
    else {
      let newData = catalogData;
      if (gender) {
        newData = newData.filter(dt => dt.gender.toLowerCase() === gender);
      }
      if (filteredMinAge) {
        newData = newData.filter(dt => parseInt(dt.age, 10) >= filteredMinAge);
      }
      if (filteredMaxAge) {
        newData = newData.filter(dt => parseInt(dt.age, 10) <= filteredMaxAge);
      }
      if (sortOption !== null) {
        newData = sortData(newData, sortOption);
      }
      if (searchTerm) {
        newData = newData.filter(dt =>
          safeToLower(dt.name).includes(searchTerm.toLowerCase()) ||
          // safeToLower(dt.occupation.occupation).includes(searchTerm.toLowerCase()) ||
          safeToLower(dt.occupation).includes(searchTerm.toLowerCase()) ||
          safeToLower(dt.status).includes(searchTerm.toLowerCase()) ||
          // safeToLower(dt.occupation.occupational_group).includes(searchTerm.toLowerCase()) ||
          safeToLower(dt.occupational_group).includes(searchTerm.toLowerCase()) ||
          // safeToLower(dt.industry.industry).includes(searchTerm.toLowerCase()) ||
          safeToLower(dt.industry).includes(searchTerm.toLowerCase()) ||
          safeToLower(dt.gender).includes(searchTerm.toLowerCase())
        );
      }
      setFilteredData(newData);
    }
  }, [gender, filteredMaxAge, filteredMinAge, filters, sortOption, searchTerm])

  const handleCheckboxChange = (label) => (event) => {
    const checked = event.target.checked;

    setCheckboxStates((prevState) => ({
      ...prevState,
      [label]: checked,
    }));

    setFilters((prevFilters) => {
      if (checked) {
        if (!prevFilters.includes(label)) {
          return [...prevFilters, label];
        }
      } else {
        return prevFilters.filter((filter) => filter !== label);
      }
    });
  };

  const handleSortChange = (event) => {
    setSortOption(event.target.value);
  };
  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  return (
    <CatalogContext.Provider
      value={{
        handleCheckboxChange,
        checkboxStates,
        totalCount,
        filteredData,
        dataFilters,
        filters,
        clearFilters,
        gender,
        setGender,
        setFilteredMaxAge,
        setFilteredMinAge,
        filteredMinAge,
        filteredMaxAge,
        removeFilter,
        handleSortChange,
        sortOption,
        handleSearchChange,
        setFilteredData
      }}
    >
      {children}
    </CatalogContext.Provider>
  );
}

export default CatalogContextProvider;
